/**
 * THE FIRM ADMIN'S VIEW GROUP, `cutoverMatcherViews` at
 * `/api/bms/cutover-matcher-views`, on the internal session lane only (cutover
 * plan ruling 28; note 01 D.4; api-conventions §7).
 *
 * BROWSER-SAFE. The agreement page's slice imports THIS module to build its
 * transport, never the leaf's barrel, which publishes a repository that
 * reaches `@effect/sql-pg`. Kit imports are relative for the same reason.
 *
 * INTERNAL ONLY, NEVER PUBLISHED. The proposal is a screen's read over both of
 * a firm's client lists while it decides how its book moves; there is no
 * `/api/v1` twin and no scope for one. THIS BUILD ADDS NO RPC GROUP (CLAUDE.md
 * rule 3, BMS exception).
 *
 * ONE READ AND NO WRITE. The firm is named in the path and must be the
 * caller's own: another firm's id answers not found, as if it did not exist.
 * The caller must be the firm's administrator; anyone else is refused 403
 * before anything is read.
 */
import { HttpApi, HttpApiEndpoint, HttpApiGroup, OpenApi } from "@effect/platform"
import { Schema as S } from "effect"

import { withBmsErrors } from "../../../shared/presentation/errors"
import { BmsSessionMiddleware } from "../../../shared/presentation/session-middleware"
import { MatchProposal } from "../domain/proposal"

/** The firm whose proposal is read: the caller's own, or not found. */
export const MatcherProposalPath = S.Struct({ organizationId: S.UUID })

export const getMatchProposalEndpoint = HttpApiEndpoint.get(
  "getMatchProposal",
  "/organizations/:organizationId/proposal",
)
  .setPath(MatcherProposalPath)
  .addSuccess(MatchProposal)
  .annotate(OpenApi.Identifier, "getMatchProposal")
  .annotate(OpenApi.Summary, "Read the firm's client match proposal")
  .annotate(
    OpenApi.Description,
    "The firm's administrator only. One row per client in the firm's old client list, each with the book clients it may be, the bucket (certain, likely or none), what agreed and why a shared value made a pair likely. Certain pairs are pre-ticked; nothing is decided here.",
  )

export const CutoverMatcherViewsGroup = withBmsErrors(HttpApiGroup.make("cutoverMatcherViews").add(getMatchProposalEndpoint))
  .middleware(BmsSessionMiddleware)
  .prefix("/api/bms/cutover-matcher-views")

export class CutoverMatcherViewsApi extends HttpApi.make("BmsCutoverMatcherViewsApi").add(CutoverMatcherViewsGroup) {}
